export const generateImageURL = (fileName) => {
    if(!fileName) return null;
    return `${process.env.REACT_APP_API_HOST}/assets/${fileName}`
}